import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { InventoryAdjustmentRead } from '../../entities/inventory-adjustment.dto';

@Injectable()
export class InventoryAdjustmentStore extends AbstractEntityStore<InventoryAdjustmentRead> {
    constructor() {
        super(PFWmsEntities.InventoryAdjustment);
    }
}
